<template>
  <div>
    <label>
      {{ field.name }}
      <span class="text-danger" v-if="field.required || isRequired">*</span>
    </label>
    <div :class="['input-container', { error: field.validation }]">
      <datetime
        type="datetime"
        :disabled="statusCampaign != 0 && field.field_profile_type_id != 0"
        class="border-none"
        v-model="field.value"
        placeholder="DD/MM/YYYY (HH:MM)"
        format="dd/MM/yyyy (HH:mm)"
        value-zone="Asia/Bangkok"
        :ref="`Datatime`"
      >
      </datetime>
      <div
        v-if="!(statusCampaign != 0 && field.field_profile_type_id != 0)"
        class="icon-primary text-right"
        @click="$refs.Datatime.isOpen = true"
      >
        <font-awesome-icon
          icon="calendar-alt"
          class="pointer color-primary"
          color="#B41BB4"
        />
      </div>
    </div>
    <div v-if="field.validation">
      <span class="text-error">กรุณาเลือกวันที่</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "FieldDateTime",
  props: {
    field: {
      required: true,
      type: Object,
    },
    isRequired: {
      required: false,
      type: Boolean,
    },
    statusCampaign: {
      required: true,
      type: Number,
    },
  },
};
</script>

<style lang="scss" scoped>

::v-deep .vdatetime-input {
  border: none;
}
.input-container.error {
  border-color: red !important;
}
.text-error {
  color: #ff0000;
  font-size: 14px !important;
  font-weight: normal !important;
}
</style>
